export default __webpack_public_path__ + "static/media/Fourth.6a4dab3b.png";